import { I18n } from "@assets/strings";
import { useObservable } from "micro-observables";
import React from "react";
import styled from "styled-components";
import { Primary } from "@ui/components/containers/primary";
import { Secondary } from "@ui/components/containers/textBlocks";
import { Toggle } from "@ui/components/inputs/toggle";
import { row } from "@ui/components/layout";
import { gap } from "@ui/styles/utils";
import { useGroupEditorController } from "@ui/pages/group/groupEditorPage/groupEditorController/groupEditorControllerContext";

type GroupAccessModeEditorProps = React.HTMLAttributes<HTMLDivElement>;

export const GroupAccessModeEditor: React.FC<GroupAccessModeEditorProps> = ({ ...htmlProps }) => {
	const controller = useGroupEditorController();
	const group = useObservable(controller.group);

	return (
		<Container {...htmlProps}>
			<Content>
				<Toggle
					toggled={group.accessMode === "OPEN"}
					onChange={(toggled) => controller.setAccessMode(toggled ? "OPEN" : "ADMIN_CONSENT")}
				/>
				<Primary>
					<b>{I18n.t(`group.${group.type}.edit.access.label`)}</b>
				</Primary>
			</Content>
			<Secondary>{I18n.t(`group.${group.type}.edit.access.infos`)}</Secondary>
		</Container>
	);
};

const Container = styled.div`
	${gap(16)};
`;

const Content = styled.div`
	${row(10, "flex-start", "center")};

	> div {
		color: ${({ theme }) => theme.colors.secondary};
	}
`;
